import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styles from './textEditor__fontAdd.jcss'
import translate from 'core/translate'
import { api } from 'core/api/ConnectionManager'
import { uploadFonts } from 'pages/files/files.state'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import Icon from 'blocks.simple/icon/icon'
import Button from 'blocks.simple/button/button'
import { cn } from 'ethcss'
import { grid } from 'theme'
//@ts-ignore
import { addFont } from 'addstyles'

type FontItem = {
    id: number
    name: string
    companyId: number | null
}

const FontAdd = ({
    items,
    setFontList,
    onClose,
}: {
    items: FontItem[]
    setFontList: (items: any[]) => void
    onClose: () => void
}) => {
    const dispatch = useDispatch()
    const [selectedItems, setSelectedItems] = useState<FontItem[]>([])
    const [showApprove, setShowApprove] = useState<boolean>(false)

    const toggleItem = (item: FontItem, checked: boolean) => {
        console.log('asd', item)
        setSelectedItems((prev) => (checked ? [...prev, item] : prev.filter((i) => i.id !== item.id)))
    }

    const toggleAll = (checked: boolean) => {
        setSelectedItems(checked ? items : [])
    }

    const isAllSelected = items.length > 0 && selectedItems.length === items.length

    const deleteFonts = () => {
        const id = selectedItems.map((item) => item.id)

        if (!id.length) return

        api.send('deleteFont', { id }).then((res: any) => {
            setFontList(items.filter((item) => !res.id.includes(item.id)))
            setSelectedItems([])
        })
    }

    const onUpload = (files: any) => {
        dispatch(
            uploadFonts({
                files: files,
                supportedFontTypes: ['.ttf'],
                cb: (newFonts: any[]) => {
                    setFontList([...items, ...newFonts])
                    newFonts.forEach((font: any) => {
                        addFont(font.fileUrl, `font-family: ${font.name}; font-weight: normal`)
                    })
                },
            })
        )
    }

    useEffect(() => {
        if (!selectedItems.length) {
            setShowApprove(false)
        }
    }, [selectedItems.length])

    return (
        <div className={styles.root}>
            <div className={styles.title}>
                {translate('addNewFont')}
                <span className={styles.infoIcon}>i</span>
            </div>
            <div className={styles.upload}>
                <div className={styles.label}>{translate('fontFile')}</div>
                <div className={styles.uploadRow}>
                    <input className={styles.input} disabled placeholder={translate('selectTtfFile')} />
                    <label className={styles.button}>
                        {translate('select')}
                        <input
                            type="file"
                            accept=".ttf"
                            hidden
                            multiple
                            onChange={(e) => {
                                if (e.target.files) {
                                    const result: File[] = []
                                    for (let i = 0; i < e.target.files.length; i++) {
                                        const file = e.target.files.item(i)
                                        if (file) result.push(file)
                                    }
                                    onUpload(result)
                                }
                            }}
                        />
                    </label>
                </div>
            </div>
            <div className={styles.list}>
                <div className={styles.listHeader}>
                    <Checkbox
                        mod={'circle'}
                        onClick={(selected: boolean) => {
                            toggleAll(selected)
                        }}
                        checked={isAllSelected}
                    />
                    <span className={styles.listTitle}>{translate('fontList')}</span>
                    <div className={cn(styles.headerIcons)}>
                        <Icon
                            onClick={() => selectedItems.length > 0 && setShowApprove(true)}
                            disabled={!selectedItems.length}
                            type={'delete'}
                        />
                        {showApprove && (
                            <div className={cn(grid.colCenter, grid.p_microPlus, styles.modalSaveApprove)}>
                                <div className={cn(grid.w80, grid.mb_md, grid.pt_microPlus)}>
                                    {translate('confirmDeleteElements')}
                                </div>
                                <div className={cn(grid.row, grid.justify, grid.mb_mini)}>
                                    <Button
                                        mod="fill"
                                        className={cn(grid.mr_mini)}
                                        onClick={() => {
                                            onClose()
                                            setShowApprove(false)
                                            deleteFonts()
                                        }}
                                    >
                                        {translate('yes')}
                                    </Button>
                                    <Button
                                        animation={false}
                                        onClick={() => {
                                            setShowApprove(false)
                                        }}
                                    >
                                        {translate('no')}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.itemsWrapper}>
                    {items
                        .filter((item) => item.companyId)
                        .map((item) => {
                            const checked = selectedItems.some((i) => i.id === item.id)
                            return (
                                <div key={item.id} className={styles.item}>
                                    <Checkbox
                                        mod={'circle'}
                                        onClick={(selected: boolean) => {
                                            toggleItem(item, selected)
                                        }}
                                        checked={checked}
                                        className={'test-font-chbx'}
                                    />
                                    <span className={styles.fontName}>{item.name}</span>
                                </div>
                            )
                        })}
                </div>
            </div>
            <div className={styles.footer}>
                <Button rounded="full_md" indentSize="mini" onClick={onClose} className={cn(grid.mr_md)}>
                    {translate('cancel')}
                </Button>
                <Button rounded="full_md" indentSize="mini" mod="fill" onClick={onClose}>
                    {translate('save')}
                </Button>
            </div>
        </div>
    )
}

export default FontAdd
